import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AbsAuthService, AuthApiService } from "src/app/shared/services/auth.svc";
import { DataService } from "src/app/shared/services/data.svc";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
  providers:[{provide: AbsAuthService, useClass: AuthApiService}],
  encapsulation: ViewEncapsulation.None
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";
  public user: any;

  constructor(public router: Router, private svcAuth: AbsAuthService, private svcData: DataService) {
    this.user = JSON.parse(localStorage.getItem("currentUser"));
    //console.log(this.user);
    if (JSON.parse(localStorage.getItem("currentUser"))) {
    } else {
    }
  }

  ngOnInit() {}

  logout = function() {
    // this.router.navigateByUrl('auth/login');
    // logout = function() {
      var _usr = '';
      if(this.svcAuth.getCurrentUser() != null){
        var user = this.svcAuth.getCurrentUser();
        user.status = 0;
        _usr = user.userId;
        //this.svcData.deleteToken(localStorage.getItem('fcmToken').toString(), _usr.toString()).subscribe();
        this.svcData.sessionUpdate(user).subscribe();
      }
      
      this.svcAuth.logout();
      
      
      this.router.navigate(['/auth/login']);
    // }
  }
}
